import { AbstractModel } from "@gipi-pages/abstract/models/abstract.model";
import { TypeFilterClient } from "../enums/type-filter-client.enum";
import { NotificationClientFilterClientClassification } from "./notification-client-filter-client-classification.model";
import { NotificationClientFilterClient } from "./notification-client-filter-client.model";

export class NotificationClientFilterModel extends AbstractModel {

    classificationFilterList: NotificationClientFilterClientClassification[];

    clientFilterList: NotificationClientFilterClient[];

    filterType: TypeFilterClient;

    constructor() {
        super();
        this.clientFilterList = [];
    }

}
